export default __webpack_public_path__ + "static/media/CABINET_JUMPYGUY.efd33b67.png";